import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTemplateCategoriesRequest } from "../store/slice/appSlice";
import { CUSTOM_INVITATION_START_PRICE } from "../config/appConstants";

const CustomTemplateProcess = () => {
  const dispatch = useDispatch();

  const isApp =
    new URLSearchParams(window.location.search).get("source") === "app";

  const { getTemplateCategoriesData } = useSelector((state) => state.app);

  const [category, setCategory] = useState("");
  const [showModal, setShowModal] = useState(false);

  const categories = getTemplateCategoriesData || [];

  useEffect(() => {
    dispatch(getTemplateCategoriesRequest());
  }, [dispatch]);

  // 🔒 Prevent scroll when modal open
  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  const mailBody = encodeURIComponent(
`Hello GreetIndia9 Team,

I want to create a custom invitation.

👉 Template ID (if selected):
👉 Category: ${category}

👉 Name:
👉 Date & Time:
👉 Venue:
👉 Details:

👉 Countdown Slides Required: Yes / No
👉 Countdown Days: (5 / 7 / 10)

Thank You`
  );

  return (
    <div className="bg-gray-50 min-h-screen text-gray-800">

      {/* HEADER */}
      {!isApp && (
        <header className="bg-white border-b">
          <div className="max-w-4xl mx-auto px-6 py-6">
            <h1 className="text-3xl font-bold">
              Custom Invitation Service
            </h1>
            <p className="text-gray-500 mt-1">
              Get your personalized invitation designed by our team
            </p>
          </div>
        </header>
      )}

      <main className="max-w-4xl mx-auto px-5 py-5 bg-white shadow rounded-2xl mt-4 mb-20">

        {/* HERO */}
        <div className="bg-gradient-to-r from-orange-100 to-yellow-100 p-5 rounded-xl text-center mb-6">
          <h2 className="text-xl font-semibold">
            Create Your Custom Invitation 🎉
          </h2>

          <p className="text-sm mt-2">
            Share your details and our team will design a unique invitation for you.
          </p>

          <p className="mt-3 text-2xl font-bold text-orange-600">
            Starting ₹{CUSTOM_INVITATION_START_PRICE} /-
          </p>

          <p className="text-xs text-gray-600 mt-1">
            ✔ Premium Design • ✔ Fast Delivery • ✔ Dedicated Support
          </p>
        </div>

        {/* HOW TO REQUEST */}
        <section className="mb-6">
          <h3 className="font-semibold text-lg mb-2">How to Request</h3>

          <ul className="list-disc list-inside text-sm space-y-1">
            <li>Select any template from app (optional)</li>
            <li>Note Template ID (Example: T16)</li>
            <li>Select category below</li>
            <li>Click on <strong>"Send Email"</strong></li>
            <li>Fill details and send request</li>
            <li>Select if you want Countdown Slides (5, 7, 10 days)</li>
          </ul>
        </section>

        {/* CATEGORY */}
        <section className="mb-6">
          <h3 className="font-semibold mb-2">Select Category</h3>

          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="border p-2 rounded w-full"
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>

          <p className="text-xs text-gray-500 mt-1">
            Example: Wedding, Birthday, Baby Shower, etc.
          </p>
        </section>

        {/* DETAILS */}
        <section className="mb-6">
          <h3 className="font-semibold mb-2">Required Details</h3>

          <ul className="list-disc list-inside text-sm space-y-1">
            <li>Template ID (if selected)</li>
            <li>Category</li>
            <li>Name(s)</li>
            <li>Date & Time</li>
            <li>Venue</li>
            <li>Photos / Videos</li>
            <li>Custom message</li>
          </ul>
        </section>

        {/* COUNTDOWN FEATURE */}
        <section className="mb-6">
          <div className="bg-gradient-to-r from-purple-100 to-pink-100 p-5 rounded-xl shadow">

            <h3 className="font-semibold text-lg mb-2">
              🎬 Premium Countdown Slides Included
            </h3>

            <p className="text-sm text-gray-700 mb-3">
              Build excitement with “Days to Go” slides before your event.
            </p>

            <div className="flex flex-wrap gap-2 justify-center mb-3">
              {["10 Days to Go", "7 Days to Go", "5 Days to Go"].map((item) => (
                <span
                  key={item}
                  className="bg-white text-purple-700 px-3 py-1 rounded-full text-xs font-semibold shadow"
                >
                  {item}
                </span>
              ))}
            </div>

            <p className="text-xs text-purple-700 text-center font-medium">
              🔥 Most popular for wedding & birthday invitations
            </p>
          </div>
        </section>

        {/* CONTACT */}
        <section className="text-center mt-8">

          <p className="text-sm mb-2 font-semibold">
            🚀 Get Your Custom Invitation Now
          </p>

          <p className="text-lg font-semibold text-orange-600">
            greetindia9@gmail.com
          </p>

          <p className="text-xs text-gray-500 mt-1">
            Our team will respond within 24 hours
          </p>

          <button
            onClick={() =>
              navigator.clipboard.writeText("greetindia9@gmail.com")
            }
            className="text-sm text-blue-600 underline mt-1"
          >
            Copy Email
          </button>

          {/* EMAIL BUTTON */}
          <a
            onClick={(e) => {
              if (!category) {
                e.preventDefault();
                setShowModal(true);
              }
            }}
            href={`mailto:greetindia9@gmail.com?subject=Custom Invitation Request&body=${mailBody}`}
            className="block mt-4 bg-gradient-to-r from-orange-500 to-yellow-500 text-white py-3 rounded-lg font-semibold shadow hover:scale-[1.02] transition"
          >
            📧 Send Email Request
          </a>

          <p className="text-xs text-gray-500 mt-3">
            If button does not work, send email manually.
          </p>

        </section>

      </main>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

          <div className="bg-white rounded-xl p-5 w-[90%] max-w-sm shadow-xl text-center">

            <h3 className="text-lg font-semibold mb-2">
              ⚠️ Required
            </h3>

            <p className="text-sm text-gray-600 mb-4">
              Please select a category before sending your request.
            </p>

            <button
              onClick={() => setShowModal(false)}
              className="bg-orange-500 text-white px-4 py-2 rounded-lg"
            >
              OK
            </button>

          </div>

        </div>
      )}

    </div>
  );
};

export default CustomTemplateProcess;